module.exports = __webpack_public_path__ + "static/media/Tom Burkewitz‎ 01.fe7ecaa8.jpg";